export const SET_CURRENT_FEATURE_LICENCE = "SET_CURRENT_FEATURE_LICENCE";
export const LICENCE_CREATE_NEW_PARTS_HANDLER =
  "LICENCE_CREATE_NEW_PARTS_HANDLER";
